import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  LinearProgress,
} from "@mui/material";
import {
  EmojiEvents as TrophyIcon,
  Star as StarIcon,
  Lock as LockIcon,
} from "@mui/icons-material";

const getAchievementIcon = (category, unlocked) => {
  if (!unlocked) return <LockIcon />;
  switch (category) {
    case "milestone":
      return <TrophyIcon />;
    case "performance":
      return <StarIcon />;
    case "streak":
      return <TrophyIcon />;
    case "speed":
      return <StarIcon />;
    default:
      return <TrophyIcon />;
  }
};

const getAchievementColor = (category) => {
  switch (category) {
    case "milestone":
      return "primary";
    case "performance":
      return "success";
    case "streak":
      return "warning";
    case "speed":
      return "info";
    default:
      return "default";
  }
};

const TriviaAchievements = ({ achievements, catalog, isLoading }) => {
  if (isLoading) {
    return (
      <Box>
        <LinearProgress />
        <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
          Loading achievements...
        </Typography>
      </Box>
    );
  }

  const items =
    catalog?.length > 0
      ? catalog.slice(0, 12)
      : (achievements || []).map((entry) => ({
          id: entry.achievement?.id,
          name: entry.achievement?.name,
          description: entry.achievement?.description,
          category: entry.achievement?.category,
          points: entry.points,
          unlocked: true,
          unlockedAt: entry.unlockedAt,
        }));

  if (!items.length) {
    return (
      <Typography color="text.secondary">
        Achievements will appear here once the catalog loads.
      </Typography>
    );
  }

  const unlockedCount = items.filter((item) => item.unlocked).length;

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
        Achievements ({unlockedCount}/{items.length})
      </Typography>

      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id || item.name}>
            <Card
              sx={{
                height: "100%",
                opacity: item.unlocked ? 1 : 0.72,
                border: item.unlocked ? undefined : "1px dashed",
                borderColor: item.unlocked ? undefined : "divider",
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                  <Avatar
                    sx={{
                      bgcolor: item.unlocked
                        ? `${getAchievementColor(item.category)}.main`
                        : "action.selected",
                      mr: 2,
                    }}
                  >
                    {getAchievementIcon(item.category, item.unlocked)}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle1" fontWeight={700}>
                      {item.unlocked ? item.name : "Locked"}
                    </Typography>
                    {item.points != null && (
                      <Chip label={`${item.points} XP`} size="small" variant="outlined" />
                    )}
                  </Box>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TriviaAchievements;
